import { TagERP, TagType } from "@finanedi.es/storybook"
import {
  faCircleCheck,
  faCircleXmark,
  faClock,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GetCesionByFiltersDtoProps } from "api/DTOs/GetCesionByFiltersDto"
import { t } from "i18next"
import { ESTADO_REVISION_CESIONES } from "../constants/EstadoRevisionCesiones"

export const EstadoRevisionActual = ({
  estado,
  id,
}: GetCesionByFiltersDtoProps) => {
  const ESTADO_REVISION_PROPERTIES: Record<
    number,
    {
      icon: React.ReactNode
      color: TagType
      text: string
    }
  > = {
    [ESTADO_REVISION_CESIONES.CREADA]: {
      icon: <FontAwesomeIcon icon={faClock} />,
      color: "alternativeOne",
      text: t("filters.estadoRevision.pendingLabel"),
    },
    [ESTADO_REVISION_CESIONES.COMUNICADA]: {
      icon: <FontAwesomeIcon icon={faCircleCheck} />,
      color: "success",
      text: t("filters.estadoRevision.sendLabel"),
    },
    [ESTADO_REVISION_CESIONES.ACEPTADA]: {
      icon: <FontAwesomeIcon icon={faCircleCheck} />,
      color: "success",
      text: t("filters.estadoRevision.aceptedLabel"),
    },
    [ESTADO_REVISION_CESIONES.RECHAZADA]: {
      icon: <FontAwesomeIcon icon={faCircleXmark} />,
      color: "danger",
      text: t("filters.estadoRevision.rejectedLabel"),
    },
  }

  const { icon, color, text } =
    (estado && ESTADO_REVISION_PROPERTIES[estado]) || {}

  return (
    <div className='tw-flex tw-justify-center tw-items-center !tw-w-full'>
      <TagERP
        id={id}
        value={text}
        color={color ?? "alternativeOne"}
        icon={icon}
      />
    </div>
  )
}
